import { render, staticRenderFns } from "./SemenCollectionsTwoPage.vue?vue&type=template&id=c2149344&scoped=true&"
import script from "./SemenCollectionsTwoPage.vue?vue&type=script&lang=js&"
export * from "./SemenCollectionsTwoPage.vue?vue&type=script&lang=js&"
import style0 from "./SemenCollectionsTwoPage.vue?vue&type=style&index=0&id=c2149344&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2149344",
  null
  
)

export default component.exports